import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f5f5",
    padding: "2rem",
  },
  card: {
    width: "100%",
    maxWidth: "400px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    padding: "2rem",
  },
  title: {
    marginBottom: "1.5rem",
    fontSize: "1.75rem",
    textAlign: "center",
    color: "#111",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "0.9rem",
    color: "#333",
  },
  input: {
    marginTop: "0.25rem",
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "border-color 0.2s",
  },
  inputFocusColor: "#f43f5e",
  button: {
    marginTop: "1rem",
    padding: "0.75rem",
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#fff",
    background: "#f43f5e",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background 0.2s",
  },
  buttonHoverColor: "#e11d48",
  error: {
    marginTop: "1rem",
    color: "#e11d48",
    textAlign: "center",
    fontSize: "0.9rem",
  },
};

const Signup = () => {
  const [email, setEmail]                 = useState("");
  const [password, setPassword]           = useState("");
  const [confirmPassword, setConfirmPwd]  = useState("");
  const [error, setError]                 = useState("");
  const [isLoading, setIsLoading]         = useState(false);
  const navigate                          = useNavigate();

  const validEmail = (e) =>
    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(e.trim());

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setIsLoading(true);

  // client‐side validation
  if (!validEmail(email)) {
    setError("Bad email");
    setIsLoading(false);
    return;
  }
  if (password.length < 8) {
    setError("Password must be ≥8 chars");
    setIsLoading(false);
    return;
  }
  if (password !== confirmPassword) {
    setError("Passwords do not match");
    setIsLoading(false);
    return;
  }

  try {
    const api = "https://qf-v1.onrender.com";
    const res = await fetch(`${api}/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: email, password }),
    });

    if (!res.ok) {
      // We ignore the real payload here and just show our waitlist text

      setError("You have been added to the waitlist");
      return;
    }

    // success → same waitlist text
    setError("You have been added to the waitlist");
    setEmail("");
    setPassword("");
    setConfirmPwd("");
  } catch (_) {
    // on network errors, still show the same message
    setError("You have been added to the waitlist");
  } finally {
    setIsLoading(false);
  }
};


  // helpers to toggle focus/hover styles
  const handleFocus = (e) => e.currentTarget.style.borderColor = styles.inputFocusColor;
  const handleBlur  = (e) => e.currentTarget.style.borderColor = "#ccc";
  const handleMouseEnter = (e) => e.currentTarget.style.background = styles.buttonHoverColor;
  const handleMouseLeave = (e) => e.currentTarget.style.background = styles.button.background;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Create a QuickFit Account</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Email
            <input
              type="email"
              style={styles.input}
              onFocus={handleFocus}
              onBlur={handleBlur}
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </label>

          <label style={styles.label}>
            Password
            <input
              type="password"
              style={styles.input}
              onFocus={handleFocus}
              onBlur={handleBlur}
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </label>

          <label style={styles.label}>
            Confirm Password
            <input
              type="password"
              style={styles.input}
              onFocus={handleFocus}
              onBlur={handleBlur}
              placeholder="••••••••"
              value={confirmPassword}
              onChange={e => setConfirmPwd(e.target.value)}
              minLength={8}
              required
            />
          </label>

          <button
            type="submit"
            style={styles.button}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            disabled={isLoading}
          >
            {isLoading ? "Signing up…" : "Sign up"}
          </button>
        </form>

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

export default Signup;
